import { Reveal } from "@/components/Reveal";
import { HOME } from "@/constants/testIds";
import { FAQS } from "@/lib/constants";

export const Faq = () => (
    <section id="faq" data-testid={HOME.faq} aria-label="questions, plainly — playlist submission FAQ" className="border-b border-[var(--rule)]">
        <div className="mx-auto max-w-[1240px] px-6 sm:px-10 lg:px-16 py-20 sm:py-24 lg:py-28">
            <Reveal>
                <p className="eyebrow text-[var(--terracotta-ink)]">04 — questions</p>
                <h2 className="font-display mt-6 text-4xl sm:text-5xl max-w-[18ch]">questions, plainly — playlist submission FAQ</h2>
            </Reveal>

            <dl className="mt-14 border-t border-[var(--rule)]">
                {FAQS.map((item, i) => (
                    <Reveal key={item.q} delay={0.03 * i}>
                        <div
                            data-testid={HOME.faqItem(i)}
                            className="grid gap-4 sm:grid-cols-[minmax(0,1fr)_minmax(0,1.3fr)] border-b border-[var(--rule)] py-8"
                        >
                            <dt className="font-bold uppercase tracking-[0.02em] text-sm sm:text-base max-w-[26ch]">
                                {item.q}
                            </dt>
                            <dd className="prose-body text-base max-w-[52ch]">{item.a}</dd>
                        </div>
                    </Reveal>
                ))}
            </dl>
        </div>
    </section>
);
